// Renders a time string with every digit in a fixed-width slot so ticking never shifts layout.
export default function SteadyDigits({ text, slot = "0.62em" }: { text: string; slot?: string }) {
  return (
    <>
      {Array.from(text).map((ch, i) =>
        /\d/.test(ch) ? (
          <span key={i} className="inline-block text-center" style={{ width: slot }}>
            {ch}
          </span>
        ) : (
          <span key={i}>{ch}</span>
        ),
      )}
    </>
  );
}
